<template>
	<div :class="`mb${gap}`">
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">{{ $t("actions") }}</div>
		</div>

		<!-- Body -->
		<div>
			<div class="xs-12 flex">
				<div class="xs-9 pr4">
					<j-base-select
						v-model="form.actionId"
						:options="options.actions"
						:placeholder="$t('select_action')"
					/>
				</div>
				<div class="flex xs-3 xs-right">
					<j-button
						:isDisabled="form.actionId ? false : true"
						@click="onClickContinue"
						>{{ $t("continue") }}</j-button
					>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<core-modal name="policy_actions" :headline="computedName" width="800">
			<div class="p4">
				<component
					:is="form.actionId"
					:policyId="policyId"
					@done="onDone"
					@notification:sent="afterSendEmail"
				/>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import CoreModal from "@/modules/core/components/CoreModal"
import ActionGetPdfFile from "./ActionGetPdfFile.vue"
import ActionIssuePolicy from "./ActionIssuePolicy.vue"
import ActionSendEmail from "./ActionSendEmail.vue"

export default {
	components: {
		JBaseSelect,
		JButton,
		JCard,
		CoreModal,
		ActionGetPdfFile,
		ActionIssuePolicy,
		ActionSendEmail
	},

	props: {
		policyId: {
			type: String
		},
		hasContractHolder: {
			type: Boolean
		},
		hasProduct: {
			type: Boolean
		},

		/**
		 * Vertical gap between fields
		 * It translates into mb{gap} class
		 */
		gap: {
			type: String,
			default: "4"
		}
	},

	data() {
		return {
			form: {
				actionId: null
			},

			options: {
				actions: ["hkecic", "hkecic_uat", "fiLife_uat", "fiLife"].includes(
					this.$store.state.tenantId
				)
					? [
							{
								name: "Issue Policy",
								value: "ActionIssuePolicy"
							}
					  ]
					: ["apeiron_uat"].includes(this.$store.state.tenantId)
					? [
							{
								name: "Issue Policy",
								value: "ActionIssuePolicy"
							},
							{
								name: "Get PDF File",
								value: "ActionGetPdfFile"
							},
							{
								name: "Send Email",
								value: "ActionSendEmail"
							}
					  ]
					: [
							{
								name: "Issue Policy",
								value: "ActionIssuePolicy"
							},
							{
								name: "Get PDF File",
								value: "ActionGetPdfFile"
							}
					  ]
			}
		}
	},

	computed: {
		computedName() {
			return this.options?.actions?.find(
				item => item.value === this.form.actionId
			)?.name
		}
	},

	methods: {
		onClickContinue() {
			if (this.form.actionId === "ActionIssuePolicy") {
				if (!this.hasContractHolder) {
					this.$store.dispatch("addMessage", {
						message: {
							type: "error",
							text: this.$t("errors.issue_without_holder")
						}
					})
					return
				}
				if (!this.hasProduct) {
					this.$store.dispatch("addMessage", {
						message: {
							type: "error",
							text: this.$t("errors.issue_without_product")
						}
					})
					return
				}
			}

			this.$modal.show("policy_actions")
		},

		onDone() {
			// Hide modal after timeout
			setTimeout(() => this.$modal.hide("policy_actions"), 250)

			// Show success message
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: "Action was successful, yay!"
				}
			})

			this.$emit("action:done")
		},

		afterSendEmail() {
			this.$modal.hide("policy_actions")

			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("email_was_sent")
				}
			})

			this.$emit("action:done")
		}
	}
}
</script>
